import { IAssessmentBookingRequest } from "../entities-generated/models/project/assessment-booking-request";
import { IProjectAssessmentEditingModel } from "../entities-generated/models/project/project-assessment-editing-model";
import { IProjectIncentiveEditingModel } from "../entities-generated/models/project/project-incentive-editing-model";
import { IProjectListing } from "../entities-generated/models/project/project-listing";
import { IRecordAssessmentRequest } from "../entities-generated/models/project/record-assessment-request";
import { IRecordAssessmentResponse } from "../entities-generated/models/project/record-assessment-response";
import { IRescheduleAssessmentRequest } from "../entities-generated/models/project/reschedule-assessment-request";
import { IUpdateIncentivesRequest } from "../entities-generated/models/project/update-incentives-request";
import { ApiClient } from "./admin-api-client";

class ProjectAssessmentApiClientClass {
  public bookProjectAssessment(request: IAssessmentBookingRequest, projectId: string) {
    return ApiClient.post<IProjectListing[]>(`projects/${projectId.replace('.', '-')}/assessment/schedule`, request);
  }

  public rescheduleProjectAssessment(request: IRescheduleAssessmentRequest, projectId: string) {
      return ApiClient.put<IProjectListing[]>(`projects/${projectId.replace('.', '-')}/assessment/reschedule`, request);
  }

  public getAssessmentBooking(projectId: string) {
    return ApiClient.get<IProjectAssessmentEditingModel>(`projects/${projectId.replace('.', '-')}/assessment`);
  }

  public getLiveProject(projectId: string) {
    return ApiClient.get<IProjectIncentiveEditingModel>(`projects/${projectId.replace('.', '-')}/live`);
  }

  public markCustomerUnresponsive(projectId: string) {
    return ApiClient.patch<void>(`projects/${projectId.replace('.', '-')}/unresponsive`, {});
  }

  public markCustomerDisinterested(projectId: string) {
    return ApiClient.patch<void>(`projects/${projectId.replace('.', '-')}/disinterested`, {});
  }

  public recordProjectAssessment(request: IRecordAssessmentRequest, projectId: string) {
    return ApiClient.put<IRecordAssessmentResponse>(`projects/${projectId.replace('.', '-')}/assessment`, request);
  }

  public updatePurchaseIncentives(request: IUpdateIncentivesRequest, projectId: string) {
    return ApiClient.put<void>(`projects/${projectId.replace('.', '-')}/incentives`, request);
  }
}

export const ProjectAssessmentApiClient = new ProjectAssessmentApiClientClass();